import * as React from "react";

function SvgAddAudience(props) {
  return <svg width={39} height={22} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x={0.5} y={0.5} width={38} height={21} rx={10.5} stroke="#006890" /><path d="M28.875 12.375h3.078v-1.734h-3.078V7.414h-1.758v3.227h-3.07v1.734h3.07v3.227h1.758v-3.227z" fill="#006890" /><path d="M11 17a6.026 6.026 0 01-5-2.667c.025-1.667 3.334-2.583 5-2.583 1.667 0 4.975.916 5 2.583A6.026 6.026 0 0111 17zm0-11.834a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0-2.5A8.333 8.333 0 1019.334 11c0-4.609-3.75-8.334-8.334-8.334z" fill="#2A678C" /></svg>;
}

export default SvgAddAudience;